var map = {
	"./en-us.json": [
		290,
		12
	],
	"./pt-br.json": [
		291,
		11
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 185;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/translate/languages lazy ^\.\/.*\.json$
// module id = 185
// module chunks = 42